import { Table } from "react-bootstrap";
import type { TaxConstraintsData } from "../lib/explainTypes";

interface Props {
  taxConstraints: TaxConstraintsData | null;
  isTaxable: boolean;
}

// Skipped (rendered as disabled placeholder) for non-taxable
// accounts -- `tax_constraints === null` is the canonical empty state
// per architecture spec §3.4 + §12 rule 4. Williams Serena pattern.
//
// `tax_budget` / `available_tax_budget` are MTAX-only (s-tax-budget §2):
// HIFO/FIFO/VSP accounts have no dollar tax cap, so the rows are
// suppressed rather than displayed as "—".
export default function TaxConstraintsSection({
  taxConstraints,
  isTaxable,
}: Props) {
  if (!isTaxable) {
    return (
      <div className="text-muted">
        Tax-free account (no tax constraints apply).
      </div>
    );
  }
  if (!taxConstraints) {
    // Taxable account whose emitter did not populate the slice -- a data
    // gap, distinct from the tax-free empty state above.
    return <div className="text-muted">Tax constraints data unavailable.</div>;
  }
  const isMtax = taxConstraints.lot_selection_method === "MTAX";
  return (
    <Table size="sm" responsive>
      <tbody>
        {isMtax && (
          <>
            <tr>
              <th>Tax budget</th>
              <td>{taxConstraints.tax_budget ?? "—"}</td>
            </tr>
            <tr>
              <th>Available tax budget</th>
              <td>{taxConstraints.available_tax_budget ?? "—"}</td>
            </tr>
          </>
        )}
        <tr>
          <th>ST gains budget</th>
          <td>{taxConstraints.gains_budget_st ?? "—"}</td>
        </tr>
        <tr>
          <th>LT gains budget</th>
          <td>{taxConstraints.gains_budget_lt ?? "—"}</td>
        </tr>
        {taxConstraints.budget_limited_sells.length > 0 && (
          <tr>
            <th>Budget-limited sells</th>
            <td>{taxConstraints.budget_limited_sells.join(", ")}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
